import {Injectable} from '@angular/core';
import {Subject} from "rxjs";
import {FilterModelDto} from "../models/filter.model";

@Injectable({
  providedIn: 'root'
})
export class FilterSettingService {

  filterSet$: Subject<FilterModelDto> = new Subject<FilterModelDto>()
  filterItemReset$: Subject<FilterModelDto> = new Subject<FilterModelDto>()
  filterAllReset$: Subject<void> = new Subject<void>()
  filterAdditionalReset$: Subject<void> = new Subject<void>()

  filterSetData$: Subject<any> = new Subject<any>()
  filterSearchWord$: Subject<string | undefined> = new Subject<string | undefined>()
  filterSelected$: Subject<void> = new Subject<void>()

  inputSearch$: Subject<FilterModelDto | undefined> = new Subject<FilterModelDto | undefined>()

  responseSearchData$: Subject<FilterModelDto[]> = new Subject<FilterModelDto[]>()

  constructor() {
  }
}
